<ngx-spinner bdColor="rgb(0, 36, 71)" size="medium" color="#00a886" type="fire" [fullScreen]="true">
  <p style="color: white"> </p>
</ngx-spinner>